/*! (c) Softem | MIT license */
import Enumerable from "linq";
import { commonStore } from "~/store/CommonStore";
const applyTo = (pagination, query) => {
    if (!query) {
        return query;
    }
    if (pagination.rowsPerPage > 0) {
        query.limit = pagination.rowsPerPage;
        query.offset = (pagination.page - 1) * pagination.rowsPerPage;
    }
    else {
        query.limit = null;
        query.offset = null;
    }
    if (pagination.sortBy) {
        // 元はdecendingの比較のみでdesc or asc を決めていましたが、複数条件に対応できなかったので既存に影響が出ないようにこのように対応しました。
        query.orderBy = Enumerable.from(pagination.sortBy.split(","))
            .select((sortKey, index) => {
            if (typeof pagination.descending === "boolean") {
                return sortKey + (pagination.descending ? " desc" : " asc");
            }
            return sortKey + (pagination.descending[index] ?? false ? " desc" : " asc");
        })
            .toArray()
            .join(",");
    }
    else {
        query.orderBy = null;
    }
    return query;
};
const apply = (pagination, result) => {
    pagination.rowsNumber = result?.total ?? 0;
    return result.records;
};
function resolvePagination(obj) {
    if (!obj) {
        return null;
    }
    if (obj.page != null) {
        return obj;
    }
    if (obj.pagination) {
        return obj.pagination;
    }
    return null;
}
const copy = (from, to) => {
    from = resolvePagination(from);
    to = resolvePagination(to);
    if (!from || !to) {
        return;
    }
    to.sortBy = from.sortBy;
    to.descending = from.descending;
    to.page = from.page;
    to.rowsPerPage = from.rowsPerPage;
    to.rowsNumber = from.rowsNumber;
};
/**
 * Quasar Pagination
 * https://next.quasar.dev/vue-components/table#pagination
 */
export class Pagination {
    /** テーブルのページング処理を管理するクラスです。
     * @param sortBy ソート対象のプロパティ名 半角のパスカルケース で記載する。 複数キーがある場合は「,」で区切る。
     * @param descending ソートの降順/昇順判定フラグ boolean型を渡すと全てのキーが指定の順番でソートされる。boolean[]型を渡すとキーと同じindexの順番でソートされる。
     * @param rowsPerPage ページ辺りの行数の初期値 デフォルト値でapp.ymlの設定値が入るので特に理由が無い場合は設定不要。
     */
    constructor(sortBy = "", descending = false, rowsPerPage = commonStore.mypageTableSetting.initValue) {
        //設定値取得APIで取得したapp.ymlに設定されているページ当たりの行数の初期値
        this.rowsPerPage = rowsPerPage;
        this.sortBy = sortBy;
        this.descending = descending;
        this.applyTo = function (query) {
            return applyTo(this, query);
        };
        this.apply = function (result) {
            return apply(this, result);
        };
        this.copyTo = function (to) {
            copy(this, to);
        };
        this.copyFrom = function (from) {
            copy(from, this);
        };
        this.resetPage = function () {
            this.page = 1;
        };
    }
    sortBy = "";
    descending = false;
    page = 1;
    rowsPerPage = 10;
    rowsNumber = 0;
    applyTo;
    apply;
    copyTo;
    copyFrom;
    resetPage;
    static get none() {
        let pagination = new Pagination();
        pagination.rowsPerPage = 0;
        return pagination;
    }
}
